import {
  ProjectTeamMemberRole,
  TeamMemberDto,
} from 'services/api/api-client.types.ts';
import DeleteIcon from 'assets/icons/delete.svg?react';
import CrownIcon from 'assets/icons/crown_24.svg?react';
import EmptyCrownIcon from 'assets/icons/crown_empty_24.svg?react';
import { TextButton } from 'components/uikit/buttons/TextButton.tsx';
import styles from './TeamMemberItem.module.scss';
import { DropDownInput } from 'components/uikit/inputs/dropdown/DropDownInput.tsx';
import { useScopedTranslation } from 'application/localization/useScopedTranslation.ts';
import clsx from 'clsx';
import { FeatureFlags } from 'application/constants/env-variables';
import { useAuth } from '../../../../../helpers/auth/auth-interceptor.ts';

type TeamMemberItemProps = {
  teamMember: TeamMemberDto;
  onDelete: () => void;
  onChangeResponsible: () => void;
  onChangeRole: (role: ProjectTeamMemberRole) => void;
  currentUserId: string | null;
};

export const TeamMemberItem = (props: TeamMemberItemProps) => {
  const i18nRolesOptions = useScopedTranslation(
    'Component.ProjectModal.TeamMemberItem.roles_options',
  );
  const auth = useAuth();
  const authData = auth !== 'loading' ? auth : null;
  const isSuperAdmin = !!authData?.claims.isSuperAdmin;

  const teamMemberIsCurrentUser = props.currentUserId === props.teamMember.id;

  const rolesOptions = [
    {
      role: ProjectTeamMemberRole.Viewer,
      title: i18nRolesOptions.t(ProjectTeamMemberRole.Viewer),
    },
    {
      role: ProjectTeamMemberRole.Editor,
      title: i18nRolesOptions.t(ProjectTeamMemberRole.Editor),
    },
  ];

  return (
    <div className={styles.teamMemberItemContainer}>
      <div className={styles.nameAndEmail}>
        <div className={styles.name}>{props.teamMember.fullName}</div>
        <div className={styles.email}>{props.teamMember.email}</div>
      </div>
      <div className={styles.buttons}>
        {FeatureFlags.projectPermissionsEnabled() ? (
          <DropDownInput
            className={styles.roleSelector}
            endAdornmentClassname={clsx(
              styles.roleSelectorAdornment,
              teamMemberIsCurrentUser && !isSuperAdmin
                ? styles.disabledSvg
                : '',
            )}
            classes={roleDropdownClasses}
            value={{
              role: props.teamMember.role,
              title: i18nRolesOptions.t(props.teamMember.role),
            }}
            options={rolesOptions}
            getOptionLabel={(x) => x.title}
            onValueChanged={(val) => {
              props.onChangeRole(val.role);
            }}
            required
            disabled={teamMemberIsCurrentUser && !isSuperAdmin}
          />
        ) : (
          <span></span> // Placeholder for alignment when dropdown is not shown
        )}

        {props.teamMember.role === ProjectTeamMemberRole.Responsible ? (
          <CrownIcon
            className={teamMemberIsCurrentUser ? null : styles.crown}
            onClick={
              teamMemberIsCurrentUser ? undefined : props.onChangeResponsible
            }
          />
        ) : (
          <EmptyCrownIcon
            className={styles.emptyCrown}
            onClick={props.onChangeResponsible}
          />
        )}
        <TextButton
          icon={<DeleteIcon />}
          onClick={props.onDelete}
          className={clsx(
            styles.deleteMember,
            teamMemberIsCurrentUser && styles.hidden,
          )}
        />
      </div>
    </div>
  );
};

const roleDropdownClasses = {
  option: styles.roleSelectorOption,
  input: styles.roleSelectorInput,
};
